<template>
  <div class="searchbox-container">
    <input
      ref="searchBox"
      v-model="searchBoxText"
      class="departments-searchbox searchbox form-control"
      type="text"
      :placeholder="localized ? '部署を検索' : '部署を検索'"
      :disabled="disabled"
      @keydown="onKeydown"
      @blur="onBlur"
      @change="onChange"
    />
    <span v-show="clearButtonVisibled" class="icon-x" @click="onClickedClearButton" />
    <span class="icon-magnifying-glass" icon="search" />
  </div>
</template>

<script lang="ts">
import "../icomoon/style.css";
import { VK_UP, VK_DOWN } from "./values/VirtualKey";
import { computed, defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "DepartmentsSearchBox",
  props: {
    localized: { type: Boolean, required: true },
    disabled: { type: Boolean, required: true },
    nextFocusHolder: { type: String, required: true },
    keyword: { type: String, required: true },
  },
  setup(props, { emit }) {
    // NOTE: 旧コードでは data として宣言され一度も代入されない（常に null・未参照）dead data。
    // テンプレートの ref="searchBox" 名と一致するため、Vue 2.7 では setup() から return
    // すると input 要素が束縛されるが、どこからも参照されないため挙動への影響はない。
    const searchBox = ref<HTMLDivElement | null>(null);
    const searchBoxText = ref("");

    watch(
      () => props.keyword,
      (): void => {
        searchBoxText.value = props.keyword;
      },
      { immediate: true }
    );

    const clearButtonVisibled = computed((): boolean => {
      return props.keyword.length !== 0;
    });

    const onKeydown = (event: KeyboardEvent): void => {
      // Note: event.code はIE11非対応
      switch (event.keyCode) {
        case VK_DOWN:
          event.preventDefault();
          emit("focusNext");
          break;
        case VK_UP:
          event.preventDefault();
          emit("focusPrev");
          break;
      }
    };

    const onClickedClearButton = (): void => {
      if (props.disabled) {
        return;
      }
      emit("change", "");
    };

    const onBlur = (): void => {
      emit("blur");
    };

    const onChange = (): void => {
      emit("change", searchBoxText.value);
    };

    return {
      searchBox,
      searchBoxText,
      clearButtonVisibled,
      onKeydown,
      onClickedClearButton,
      onBlur,
      onChange,
    };
  },
});
// 要注意: Haxe 経由での JQuery からのDOM変更が残っている
</script>

<style scoped lang="scss">
.searchbox {
  padding-left: 40px;
}

.searchbox-container {
  position: relative;
  height: 43px;
  vertical-align: middle;
  padding: 0px;
  overflow: hidden;
  flex-grow: 0;
  flex-shrink: 0;

  .icon-magnifying-glass {
    position: absolute;
    top: 11px;
    left: 18px;
    color: #cccccc;
  }

  .icon-x {
    position: absolute;
    top: 11px;
    right: 18px;
    color: #cccccc;
  }
}
</style>
